import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { InvoiceEmailTemplatesService } from '../../../services/invoice-email-templates.service';
import { EmailTemplate } from '../../../../dto/templates/email-template';
import { ConfirmDialogComponent } from '../../../../shared/confirm-dialog/confirm-dialog.component';

@Component( {
  selector: 'app-invoice-email-templates',
  templateUrl: './invoice-email-templates.component.html',
  styleUrls: [ './invoice-email-templates.component.css' ]
} )
export class InvoiceEmailTemplatesComponent implements OnInit {
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private dialog: MatDialog,
    private templatesService: InvoiceEmailTemplatesService ) { }


  dataSource: EmailTemplate[];

  ngOnInit() {
    this.templatesService.getMany().subscribe( result => {
      this.dataSource = result.data;
    } );
  }

  deleteTemplate( id: number ) {
    this.dialog.open( ConfirmDialogComponent ).afterClosed().subscribe( result => {
      if ( result == 'ok' ) {
        this.templatesService.delete( id ).subscribe( data => {
          const idx = this.dataSource.findIndex( x => x.id == id );
          this.dataSource.splice( idx, 1 );
        } );
      }
    } );
  }

  copyTemplate(id: number) {
    this.templatesService.copy(id).subscribe(newId => {
      this.router.navigate(['invoice-email', newId], {relativeTo: this.route});
    });
  }

}
